// Import Swiper styles
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/navigation";
import "./SuccessStoriesCarousel.SwiperOverrides.css";

import * as styles from "./SuccessStoriesCarousel.module.scss";

import React from "react";
// import Swiper core and required modules
import { A11y, Navigation, Virtual } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { useState } from "react";
import { useClientSide } from "../../hooks/useClientSide";
import { useIsTouchDevice } from "../../hooks/useIsTouchDevice";
import { Pagination } from "../Pagination/Pagination";
import {
	SuccessStoryCarouselItem,
	type SuccessStoryCarouselItemProps,
} from "./SuccessStoriesCarouselItem/SuccessStoriesCarouselItem";

export interface SuccessStoriesCarouselProps {
	stories: SuccessStoryCarouselItemProps[];
}

export const SuccessStoriesCarousel: React.FC<SuccessStoriesCarouselProps> = ({
	stories,
}) => {
	const [swiper, setSwiper] = useState(null);
	const [currentSlide, setCurrentSlide] = useState(0);
	const isClientSide = useClientSide();
	const touchDevice = useIsTouchDevice();

	if (!isClientSide) return null;
	return (
		<Swiper
			aria-label="Success stories carousel"
			className={styles.carouselcontainer}
			modules={[Virtual, Navigation, A11y]}
			spaceBetween={0}
			slidesPerView={1}
			edgeSwipeThreshold={10}
			threshold={0}
			grabCursor={true}
			longSwipes={true}
			resistance={false}
			shortSwipes={!!touchDevice}
			loop={false}
			effect="slide"
			centeredSlides={false}
			pagination={false}
			onSwiper={setSwiper}
			initialSlide={0}
			onSlideChange={(swiper) => {
				setCurrentSlide(swiper.activeIndex);
			}}
		>
			{stories.map((story) => (
				<SwiperSlide key={story.title}>
					<SuccessStoryCarouselItem {...story} />
				</SwiperSlide>
			))}
			<span className={styles.accessibilityalert} role="alert">
				{`Story ${currentSlide} of ${stories.length}`}
			</span>
			<div className={styles.pagination}>
				<Pagination
					total={stories.length}
					position={currentSlide}
					onFirstClick={() => swiper.slideTo(0)}
					onNextClick={() => swiper.slideNext()}
					onPreviousClick={() => swiper.slidePrev()}
					onLastClick={() => swiper.slideTo(stories.length - 1)}
					firstDisabled={currentSlide === 0}
					previousDisabled={currentSlide === 0}
					nextDisabled={currentSlide === stories.length - 1}
					lastDisabled={currentSlide === stories.length - 1}
				/>
			</div>
		</Swiper>
	);
};

export default SuccessStoriesCarousel;
